import { Box, InputGroup, InputLeftAddon, Input, Text } from '@chakra-ui/react'
import { memo } from 'react'
import { useFormContext } from 'react-hook-form'

export const DataHoraForm = memo(() => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <>
      <Box w="full">
        <InputGroup maxW="230px" fontSize="15px">
          <InputLeftAddon
            bg="transparent"
            pointerEvents="none"
            fontWeight="semibold"
            w="100px"
            borderColor={errors.dataRetorno ? 'red.500' : '#378BBF'}
            fontSize="14px"
          >
            Retornar:
          </InputLeftAddon>
          <Input
            _focus={{ boxShadow: 'none', borderColor: 'transparent' }}
            type="date"
            borderLeft="none"
            sx={{ p: 0, pr: 1 }}
            borderColor={errors.dataRetorno ? 'red.500' : '#378BBF'}
            {...register('dataRetorno')}
          />
        </InputGroup>
        {errors.dataRetorno && (
          <Text color="red.500" fontSize="12px">
            {errors.dataRetorno.message}
          </Text>
        )}
      </Box>
      <Box w="full">
        <InputGroup maxW="330px" fontSize="15px">
          <InputLeftAddon
            bg="transparent"
            pointerEvents="none"
            fontWeight="semibold"
            w="100px"
            borderColor={errors.horaRetorno ? 'red.500' : '#378BBF'}
            fontSize="14px"
          >
            Hora retorno:
          </InputLeftAddon>
          <Input
            _focus={{ boxShadow: 'none', borderColor: 'transparent' }}
            type="time"
            borderLeft="none"
            textAlign="center"
            sx={{ p: 0, pr: 1 }}
            borderColor={errors.horaRetorno ? 'red.500' : '#378BBF'}
            {...register('horaRetorno')}
          />
        </InputGroup>
        {errors.horaRetorno && (
          <Text color="red.500" fontSize="12px">
            {errors.horaRetorno.message}
          </Text>
        )}
      </Box>
    </>
  )
})

DataHoraForm.displayName = 'DataHoraForm'
